import React from "react";
import { IUploaderContext } from "../types";

export const UploaderContext = React.createContext<IUploaderContext>(null);
